/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.AccountTransferFundWithdrawResponse,
  AccountTransferFundWithdraw: (params: vp.AccountTransferFundWithdrawRequest) => void,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const usePostAccountTransferFundWithdraw: ApiHook = ({ api }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [shouldAccountTransferFundWithdraw, setShouldAccountTransferFundWithdraw] = useState(false);
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.AccountTransferFundWithdrawRequest>({
    DebitorClientAccountID: '',
    RecipientClientAccountID: '',
    RecipientClientAccountIDSplit: '',
    Amount: 0,
    ClientReferenceNumber: '',
    Notes: '',
    TransactionLabel: '',
    Currency: '',
  });
  const [response, setResponse] = useState<vp.AccountTransferFundWithdrawResponse>({
    Success: false,
    ErrorMessage: '',
    FundingTransactionID: '',
    WithdrawTransactionID: '',
    AccountTransferID: '',
    AccountTransferIDs: {},
    WithdrawTransactionIDs: {},
  });

  useEffect(() => {
    if (!shouldAccountTransferFundWithdraw) return () => {};

    const PostAccountTransferFundWithdraw = async () => {
      setDataFetchingInfo(true, 'processing', 'fullScreen');

      // Remove RecipientClientAccountID or RecipientClientAccountIDSplit from params as both cant be passed
      const filteredParams = { ...params };
      if (params.RecipientClientAccountIDSplit !== '') {
        delete filteredParams.RecipientClientAccountID;
      } else {
        delete filteredParams.RecipientClientAccountIDSplit;
      }

      const res = await api.postAccountTransferFundWithdraw(filteredParams, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldAccountTransferFundWithdraw) void PostAccountTransferFundWithdraw();
    setShouldAccountTransferFundWithdraw(false);
    return () => {
      source.cancel();
    };
  }, [shouldAccountTransferFundWithdraw]);

  return [
    response,
    (_params: vp.AccountTransferFundWithdrawRequest) => {
      setParams(_params);
      setShouldAccountTransferFundWithdraw(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        FundingTransactionID: '',
        WithdrawTransactionID: '',
        AccountTransferID: '',
        AccountTransferIDs: {},
        WithdrawTransactionIDs: {},
      });
      setShouldAccountTransferFundWithdraw(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostAccountTransferFundWithdraw);
